/* Henne bike builder profile: Touring Street Glide / Road Glide (used by assets/henne-bike-builder.js).
   Photos: assets/henne-bb-road-glide.webp and henne-bb-street-glide.webp (1200x675); pin positions are % of the photo. */
(function () {
  "use strict";
  var P = (window.HenneBikeBuilderProfiles = window.HenneBikeBuilderProfiles || {});

  P.touring = {
    name: "Street Glide / Road Glide",
    photoKey: function (model) { return /road glide/i.test(model) ? "road-glide" : "street-glide"; },
    group: function (model) { return /road glide/i.test(model) ? "Road Glide" : "Street Glide"; },
    captions: {
      "road-glide": "Photo: Henne build, 2024 Road Glide “OFF G”",
      "street-glide": "Photo: Henne build, 2021 Street Glide “Art Basel”"
    },
    alts: {
      "road-glide": "Customized Harley-Davidson Road Glide by Henne, side view",
      "street-glide": "Customized Harley-Davidson Street Glide by Henne, side view"
    },

    // [id, name, slots [id, label, single choice?], pin positions per photo]
    zones: [
      { id: "bars", name: "Handlebars & risers", slots: [["handlebar", "Handlebar", 1], ["risers", "Risers", 1], ["levers", "Levers & grips", 0], ["bar-extras", "Cables & wiring", 0]], pos: { "road-glide": [58, 15], "street-glide": [61, 13] } },
      { id: "frontend", name: "Front end & forks", slots: [["triple", "Triple trees", 1], ["fork", "Fork tubes", 1], ["front-extras", "Front end hardware", 0]], pos: { "road-glide": [74, 62], "street-glide": [75, 55] } },
      { id: "ffender", name: "Front fender", slots: [["ffender", "Front fender", 1], ["ffender-extras", "Fender spacers", 0]], pos: { "road-glide": [80, 54], "street-glide": [88, 52] } },
      { id: "wheels", name: "Wheels & tires", slots: [["fat-tire", "Fat tire conversion", 1]], pos: { "road-glide": [25, 86], "street-glide": [24, 89] } },
      { id: "brakes", name: "Brakes", slots: [["front-rotor", "Front rotors", 1], ["rear-rotor", "Rear rotor", 1], ["calipers", "Caliper adapters & brackets", 0]], pos: { "road-glide": [85, 74], "street-glide": [80, 67] } },
      { id: "tank", name: "Tank & dash", slots: [["tank-cover", "Tank cover", 1]], pos: { "road-glide": [55, 38], "street-glide": [58, 40] } },
      { id: "bags", name: "Saddlebags", slots: [["bags", "Saddlebags & lids", 1], ["bag-guards", "Saddlebag guards", 1]], pos: { "road-glide": [21, 50], "street-glide": [20, 63] } },
      { id: "rfender", name: "Rear fender & lights", slots: [["rfender", "Rear fender & rear conversions", 1], ["taillight", "Taillight & turn signals", 1], ["license", "License plate", 0]], pos: { "road-glide": [11, 63], "street-glide": [5, 57] } },
      { id: "luggage", name: "Sissy bar & luggage", slots: [["sissy", "Sissy bar", 1], ["rack", "Luggage rack", 1], ["docking", "Docking hardware", 0]], pos: { "road-glide": [15, 32], "street-glide": [13, 43] } },
      { id: "exhaust", name: "Exhaust", slots: [["exhaust", "Exhaust & mufflers", 1]], pos: { "road-glide": [29, 63], "street-glide": [30, 80] } },
      { id: "air", name: "Air cleaner", slots: [["air", "Air cleaner", 1]], pos: { "road-glide": [54, 53], "street-glide": [59, 58] } },
      { id: "engine", name: "Engine covers", slots: [["primary", "Primary cover", 1], ["engine-covers", "Cam, timer & clutch covers", 0]], pos: { "road-glide": [53, 68], "street-glide": [58, 74] } },
      { id: "controls", name: "Floorboards & controls", slots: [["mids", "Mid controls", 1], ["boards", "Floorboards & pegs", 1], ["linkage", "Shift support", 0]], pos: { "road-glide": [44, 77], "street-glide": [65, 81] } },
      { id: "crash", name: "Crash bars", slots: [["crash", "Engine guard", 1]], pos: { "road-glide": [64, 60], "street-glide": [71, 63] } },
      { id: "spoiler", name: "Chin spoiler", slots: [["spoiler", "Chin spoiler", 1]], pos: { "road-glide": [60, 80], "street-glide": [74, 88] } },
      { id: "susp", name: "Suspension", slots: [["rear-susp", "Rear shocks & air ride", 1], ["front-susp", "Fork cartridges", 1], ["susp-extras", "Lowering & accessories", 0]], pos: { "road-glide": [21, 71], "street-glide": [36, 89] } },
      { id: "swingarm", name: "Swingarm & drive", slots: [["swingarm", "Swingarm", 1], ["subframe", "Subframe", 1], ["chain", "Chain conversion & drive", 0]], pos: { "road-glide": [36, 71], "street-glide": [44, 82] } },
      { id: "trim", name: "Side covers & trim", slots: [["side-covers", "Side covers", 1], ["trim", "Trim", 0]], pos: { "road-glide": [35, 52], "street-glide": [40, 63] } }
    ],

    // Product type (+ title) -> [zone, slot]
    classify: function (type, t) {
      switch (type) {
        case "Handlebar": case "Conversion Kit":
          if (/Rear Conversion/i.test(t)) return ["rfender", "rfender"];
          return ["bars", "handlebar"];
        case "Rick's Risers": case "Risers": return ["bars", "risers"];
        case "Levers": case "Grips": return ["bars", "levers"];
        case "Cables": case "Wiring Harness": return ["bars", "bar-extras"];
        case "Triple Tree": return /Triple Tree/i.test(t) && !/Axle & Caliper/i.test(t) ? ["frontend", "triple"] : ["frontend", "front-extras"];
        case "Fork": return ["frontend", "fork"];
        case "Fork Cartridges": return ["susp", "front-susp"];
        case "Front Fender": return ["ffender", "ffender"];
        case "Front Fender Spacer": return ["ffender", "ffender-extras"];
        case "Fat Tire Conversion": case "Wheels": return ["wheels", "fat-tire"];
        case "Brake Rotor": return /\bRear\b/.test(t) ? ["brakes", "rear-rotor"] : ["brakes", "front-rotor"];
        case "Brake Caliper Adapters": return ["brakes", "calipers"];
        case "Fuel Tank Cover": return ["tank", "tank-cover"];
        case "Saddlebags": return ["bags", "bags"];
        case "Saddlebag Guards": return ["bags", "bag-guards"];
        case "Rear Fender": return ["rfender", "rfender"];
        case "Rear Indicators": return ["rfender", "taillight"];
        case "License Plate": return ["rfender", "license"];
        case "Sissy Bar": return ["luggage", "sissy"];
        case "Luggage Rack": return ["luggage", "rack"];
        case "Docking Hardware": return ["luggage", "docking"];
        case "Exhaust": return ["exhaust", "exhaust"];
        case "Air Filter": return ["air", "air"];
        case "Primary Cover": return ["engine", "primary"];
        case "Cam Cover": case "Timer Cover": return ["engine", "engine-covers"];
        case "Mid Controls": return ["controls", "mids"];
        case "Footpegs": case "Floorboards": return ["controls", "boards"];
        case "Shifting / Linkages": return ["controls", "linkage"];
        case "Crash Bars": return ["crash", "crash"];
        case "Chin Spoiler": return ["spoiler", "spoiler"];
        case "Air Shocks": case "Shocks": return /Spacer/i.test(t) ? ["susp", "susp-extras"] : ["susp", "rear-susp"];
        case "Lowering Kit": case "Shock Accessories": return ["susp", "susp-extras"];
        case "Swingarm": return ["swingarm", "swingarm"];
        case "Subframe": return ["swingarm", "subframe"];
        case "Chain Conversion": case "Pivot Block": case "Offset Kit": return ["swingarm", "chain"];
        case "Side Covers": return ["trim", "side-covers"];
        case "Trim":
          if (/clutch|gear position|transmission|coolant/i.test(t)) return ["engine", "engine-covers"];
          return ["trim", "trim"];
      }
      return null;
    },

    // What a variant value has to name for this bike. b = { y, m, cvo, st }
    fit: function (b) {
      var rg = /road glide/i.test(b.m);
      return {
        pos: rg ? /\btouring\b|all touring|bagger|\bcvo\b|road glide|fltr/i : /\btouring\b|all touring|bagger|\bcvo\b|street glide|flhx|\bflh\b/i,
        neg: rg
          ? /street glide|flhx|\bflh\b|road king|flhr|electra|flht|ultra limited|ultra classic|tri glide|trike|freewheeler|softail|dyna|sportster|nightster|v-?rod|fat boy|breakout|low rider|street[- ]?bob|fat bob|sport glide|heritage|deluxe|\bslim\b|pan america/i
          : /road glide|fltr|road king|flhr|electra|flht|ultra limited|ultra classic|tri glide|trike|freewheeler|softail|dyna|sportster|nightster|v-?rod|fat boy|breakout|low rider|street[- ]?bob|fat bob|sport glide|heritage|deluxe|\bslim\b|pan america/i,
        named: rg ? /road glide|fltr/i : /street glide|flhx/i
      };
    },

    // Pairings taken from the product titles ("for X"). Shown as a reminder, never blocking.
    rules: [
      { re: /21" Front Fender Spacer Kit/, need: /Rick's 21" Front Fender/, text: "For Rick's 21\" front fender." },
      { re: /Brake Caliper Adapters 13"/, need: /13"\/330mm/, text: "For 13\"/330mm front rotors." },
      { re: /X-Tree Axle & Caliper Set/, need: /X-Tree Triple Tree Set/, text: "Goes with the Raceworks X-Tree triple tree set for Öhlins forks." }
    ],
    notes: function (p) {
      var out = [];
      var m = p.t.match(/\b(19|21|23|26|30)"/);
      if (p.s === "ffender" && m) out.push("For a " + m[1] + "\" front wheel.");
      if (/^Wings Custom .* Handlebars? - /.test(p.t) && !/Kit/.test(p.t)) out.push('Handlebar only. The "Handlebar Kit with Cables" versions come with cables.');
      return out;
    },
    example: [
      [/^Raceworks Billet Swingarm RR Style/],
      [/^Raceworks Mid Controls Kit RR Style/],
      [/^Raceworks Primary Cover RR Style/],
      [/^Wings Custom Front King Rhino 2" Handlebar Kit with Cables & Wiring/, /^Wings Custom Front King Rhino 2" Handlebar Kit with Cables/],
      [/^Wings Custom King Rhino 2" Engine Guard/],
      [/^Rick's Air Filter "Good Guys 2" Apollo 5/]
    ]
  };
})();
